/** Top app chrome. Neural-eye mark + "IntraScene" wordmark (gradient "Scene") +
 *  AI badge, on a dark ink bar with a brand gradient hairline underneath.
 *
 *  The lockup width is independent of the sidebar: collapsing the nav must
 *  not hide or stack the company name. This bar clips overflow for the
 *  circuit texture, so it holds no dropdowns. */
function Wordmark() {
  return (
    <span className="flex items-center text-xl font-extrabold tracking-tight text-white">
      <span>
        Intra<span className="text-gradient">Scene</span>
      </span>
      <span className="ml-2 rounded-md bg-gradient-to-r from-brand-purple to-brand-fuchsia px-1.5 py-0.5 text-[10px] font-extrabold uppercase leading-none text-white">
        AI
      </span>
    </span>
  );
}

export default function BrandHeader() {
  return (
    <header className="relative col-span-2 overflow-hidden border-b border-white/10 bg-[#272036] shadow-lg shadow-black/30">
      {/* Faint circuit-board texture, ported from the marketing site hero */}
      <div className="cyber-bg pointer-events-none absolute inset-0 opacity-[0.07]" aria-hidden />
      <div className="relative flex items-center justify-between">
        <div className="flex items-center gap-2.5 px-4 py-3">
          <img
            src="/logo-neural-eye.svg"
            alt="IntraScene"
            className="h-9 w-9 shrink-0 drop-shadow-[0_4px_14px_rgba(124,58,237,0.45)]"
            width={36}
            height={36}
          />
          <Wordmark />
        </div>

        <div className="hidden items-center justify-end px-6 py-3 md:flex">
          <span className="text-sm font-semibold text-white/90">
            Deep understanding of{" "}
            <span className="text-gradient font-bold">every scene.</span>
          </span>
        </div>
      </div>
      <div className="bf-gradient-divider" />
    </header>
  );
}
